import { Link } from "react-router-dom";
import Bg2 from "../../assets/images/breadcrumb/bg_02.jpg";

const BreadCrumbSection = () => {
  return (
    <section className="breadcrumb_section text-center clearfix">
      <div
        className="page_title_area has_overlay d-flex align-items-center clearfix"
        data-bg-image="assets/images/breadcrumb/bg_02.jpg"
        style={{
          backgroundImage: `url(${Bg2})`,
        }}
      >
        <div className="overlay"></div>
        <div
          className="container aos-init aos-animate"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h1 className="page_title text-white mb-0">
            Choisissez votre vehicule
          </h1>
        </div>
      </div>
      <div
        className="breadcrumb_nav clearfix"
        data-bg-color="#F2F2F2"
        style={{ backgroundColor: "rgb(242, 242, 242)" }}
      >
        <div className="container">
          <ul className="ul_li clearfix">
            <li>
              <Link to={"/"}>Accueil</Link>
            </li>
            <li>
              <Link to={"/galerie"}>Nos Voitures</Link>
            </li>
            <li>Détails</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default BreadCrumbSection;
